module.exports = __webpack_public_path__ + "img/img-placeholder.f5580ad4.png";